import React, { useMemo } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useRecords } from "./Lists";
import { tNegocio } from "./shared";

const t = (key, vars) => {
  let text = tNegocio(`pages.emails.${key}`);
  if (vars) Object.entries(vars).forEach(([k, v]) => { text = text.split(`{${k}}`).join(String(v)); });
  return text;
};

/**
 * Campo de correo de una cuenta: se escribe a mano o se elige de los correos registrados
 * en Negocio › Correos (primero los que todavía no tienen cuentas).
 */
export default function EmailPickerField({ value, onChange, label, helperText, autoFocus }) {
  const emailsList = useRecords("emails");
  const options = useMemo(() => {
    const rows = Array.isArray(emailsList.records) ? emailsList.records : [];
    return [...rows].sort((a, b) => (Number(a.accounts > 0) - Number(b.accounts > 0)) || a.email.localeCompare(b.email));
  }, [emailsList.records]);

  return (
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(option) => (typeof option === "string" ? option : option?.email || "")}
      groupBy={(option) => (option.accounts > 0 ? t("pickerUsed") : t("pickerFree"))}
      filterOptions={(opts, state) => {
        const q = String(state.inputValue || "").trim().toLowerCase();
        return (q ? opts.filter((o) => o.email.includes(q)) : opts).slice(0, 50);
      }}
      inputValue={value || ""}
      onInputChange={(_, next, reason) => {
        if (reason === "reset" && !next) return;
        onChange(next);
      }}
      onChange={(_, picked) => {
        if (picked && typeof picked === "object") onChange(picked.email);
      }}
      renderOption={(option) => (
        <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <span style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis" }}>{option.email}</span>
          <span style={{ fontSize: 12, opacity: 0.7 }}>
            {option.accounts > 0 ? t("pickerAccounts", { n: option.accounts }) : t("pickerNoAccounts")}
            {option.notes ? ` · ${option.notes.slice(0, 60)}` : ""}
          </span>
        </div>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin="dense"
          variant="outlined"
          label={label}
          autoFocus={autoFocus}
          helperText={helperText || (options.length ? t("pickerHint") : undefined)}
          inputProps={{ ...params.inputProps, autoComplete: "off" }}
        />
      )}
    />
  );
}
